// extracted by mini-css-extract-plugin
export default {"gridWrap":"ResultsGrid_gridWrap__QgXgJ","sectionTitle":"ResultsGrid_sectionTitle__hTM8m","grid":"ResultsGrid_grid__DBZK2"};